<template>
  <q-card flat>
    <q-card-section>
      Chart rollover date
      <q-separator class="q-mt-sm q-mb-sm" />
      <span class="text-caption text-grey-6">
        Controls when the charts and graphs that are using subscription periods switch over to the next financial
        period. (E.g. On the 1st of July in the current year, start showing data for next financial period)
      </span>
    </q-card-section>

    <q-card-section>
      <div class="row q-col-gutter-lg">
        <q-select v-model="month" :options="months" outlined label="Month" map-options emit-value class="col-xs-6" />

        <q-select v-model="day" :options="days" outlined label="Day" class="col-xs-6" />
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import { months } from './months'
// Libraries
import moment from 'moment'

export default {
  data: () => ({
    month: null,
    day: null
  }),

  computed: {
    months() {
      return months
    },

    days() {
      const daysOfMonth = this.getDaysForMonth(this.month)
      return Array.from({ length: daysOfMonth }, (_, day) => day + 1)
    }
  },

  watch: {
    month(val) {
      const daysOfMonth = this.getDaysForMonth(val)
      if (this.day > daysOfMonth) {
        this.day = 1
      }
    }
  },

  created() {
    this.setMonthAndDay()
  },

  methods: {
    getDaysForMonth(month) {
      return moment()
        .month(month - 1)
        .daysInMonth()
    },

    setMonthAndDay() {
      const [month, day] = this.settings.chart_date_switch.split('-')
      this.month = Number(month)
      this.day = Number(day)
    },

    getData() {
      const month = ('0' + this.month).slice(-2)
      const day = ('0' + this.day).slice(-2)
      return `${month}-${day}`
    }
  }
}
</script>
